/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */

/*
* -------------------------------------------
*                LOAD WIDGET META
* -------------------------------------------
*/

export const LOAD_WIDGET_META = '@@b2b_portal_ui/dashboard/widget/LOAD_WIDGET_META';
export const LOAD_WIDGET_META_SUCCESSFUL = '@@b2b_portal_ui/dashboard/widget/LOAD_WIDGET_META_SUCCESSFUL';
export const LOAD_WIDGET_META_FAILED = '@@b2b_portal_ui/dashboard/widget/LOAD_WIDGET_META_FAILED';
